import React from 'react';

import { Alert, Typography } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

import { productTypesExpectedFields } from '~/services/PromoService';

type DisplayField = 'productType' | 'originAirportCode' | 'destinationAirportCode' | 'fareType' | 'transactionKey';

type PromoItemFieldProps = {
  field: keyof definitions['Discount Request']['order']['items']['0'] | DisplayField;
  categoryBK: definitions['Discount Request']['order']['items']['0']['categoryBK'];
  subCategoryBK?: definitions['Discount Request']['order']['items']['0']['subCategoryBK'];
  title?: string;
  value: string | number | null | object | Array<object>;
  longDescription?: string;
};

export const isExpectedField = (
  category: definitions['Discount Request']['order']['items']['0']['categoryBK'],
  subCategory: definitions['Discount Request']['order']['items']['0']['subCategoryBK'] | undefined,
  field: keyof definitions['Discount Request']['order']['items']['0'] | DisplayField,
) => {
  const categoryFields = productTypesExpectedFields[category];
  if (!categoryFields) {
    return false;
  }

  // Try specific subCategory first, then fall back to '*' (default for category)
  const match = (subCategory && categoryFields[subCategory]) || categoryFields['*'];

  if (!match) {
    return false;
  }

  return match[field] ?? false;
};

function PromoItemField({ field, categoryBK, subCategoryBK, value, title, longDescription }: PromoItemFieldProps) {
  if (!isExpectedField(categoryBK, subCategoryBK, field)) {
    return null;
  }

  if (value == null || value === '') {
    const msg = `${field} not mapped on item`;
    return (
      <Alert severity="warning" title={msg}>
        {msg}
      </Alert>
    );
  }

  return (
    <Typography component="span" title={longDescription}>
      {title && (
        <Typography component="span" fontWeight="bold">
          {title}:
        </Typography>
      )}
      {typeof value === 'object' ? JSON.stringify(value) : value}
    </Typography>
  );
}

export default PromoItemField;
